const checkboxes = [].slice.call(document.getElementsByClassName('o-input__checkbox-box'));

checkboxes.map(function (checkbox) {
    checkbox.addEventListener('click', function() {
        // Reverse the checked state
        this.previousElementSibling.checked = !this.previousElementSibling.checked;

        // Fire a changed event on the input
        var event = document.createEvent('HTMLEvents');
        event.initEvent('change', true, false);
        this.previousElementSibling.dispatchEvent(event);
    })
});



// WEBPACK FOOTER //
// ./src/js/components/checkbox.js